
export function initAttentionScopes() {
  const disposers = [];

  
  const getTriggersFrom = (el) =>
    [...el.classList]
      .map(c => c.match(/^ani-attention-scope-([a-z0-9_-]+)$/i)?.[1])
      .filter(Boolean);

  const getChildSelectorFor = (trigger) =>
    `.ani-attention-when-parent-${trigger}.ani-when-attention`;

  const forEachChild = (scope, trigger, fn) => {
    scope.querySelectorAll(getChildSelectorFor(trigger)).forEach(fn);
  };

  
  
  
  function bindTrigger(scope, trigger) {
    
    if (trigger === 'inview') {
      const onEnter = () => forEachChild(scope, trigger, el => el.classList.add('is-attention'));
      const onExit  = () => forEachChild(scope, trigger, el => el.classList.remove('is-attention'));

      scope.addEventListener('ani:inview-enter', onEnter, true);
      scope.addEventListener('ani:inview-exit',  onExit,  true);
      
      (scope.classList.contains('is-inview') ? onEnter : onExit)();

      return () => {
        scope.removeEventListener('ani:inview-enter', onEnter, true);
        scope.removeEventListener('ani:inview-exit',  onExit,  true);
      };
    }

    
    if (trigger === 'hover') {
      const onEnter = () => forEachChild(scope, trigger, el => el.classList.add('is-attention'));
      const onExit  = () => forEachChild(scope, trigger, el => el.classList.remove('is-attention'));

      scope.addEventListener('mouseenter', onEnter, true);
      scope.addEventListener('mouseleave', onExit,  true);
      
      if (scope.matches(':hover')) onEnter();

      return () => {
        scope.removeEventListener('mouseenter', onEnter, true);
        scope.removeEventListener('mouseleave', onExit,  true);
      };
    }

    
    if (trigger === 'focus' || trigger === 'focuswithin') {
      const onEnter = () => forEachChild(scope, trigger, el => el.classList.add('is-attention'));
      const onExit  = () => forEachChild(scope, trigger, el => el.classList.remove('is-attention'));

      scope.addEventListener('focusin',  onEnter, true);
      scope.addEventListener('focusout', onExit,  true);
      
      if (scope.matches(':focus-within')) onEnter();

      return () => {
        scope.removeEventListener('focusin',  onEnter, true);
        scope.removeEventListener('focusout', onExit,  true);
      };
    }

    
    const proxMatch = trigger.match(/^prox-(\d{1,3})$/);
    if (proxMatch) {
      const thr = Math.max(0, Math.min(100, parseInt(proxMatch[1], 10))) / 100;
      const onProx = (e) => {
        const s = e?.detail?.score ?? 0;
        forEachChild(scope, trigger, el => el.classList.toggle('is-attention', s >= thr));
      };
      scope.addEventListener('ani:proximity', onProx, true);
      
      return () => scope.removeEventListener('ani:proximity', onProx, true);
    }

    
    return () => {};
  }

  
  document.querySelectorAll('[class*="ani-attention-scope-"]').forEach(scope => {
    const triggers = getTriggersFrom(scope);
    triggers.forEach(t => {
      const unbind = bindTrigger(scope, t);
      disposers.push(unbind);
    });
  });

  return () => disposers.forEach(fn => { try { fn(); } catch {} });
}
